// extracted by mini-css-extract-plugin
export default {"loading":"LoadingMessage_loading__erMRP","message":"LoadingMessage_message__cFoNk"};